import React from 'react'
import clsx from 'clsx'

import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '@material-ui/core/Button'

import PauseIcon from '@material-ui/icons/Pause'
import PlayIcon from '@material-ui/icons/PlayArrow'

const useStyles = makeStyles({
    playControls: {
        position: 'absolute',
        zIndex: 2,
        opacity: 0,
        transition: 'opacity 0.3s linear',
        transform: 'translate(-50%, -50%)'
    },
    active: {
        opacity: 1
    },
    playButton: {
        borderRadius: '50%',
        height: '64px',
        width: '64px',
        padding: 0
    },
    loader: {
        position: 'absolute',
        zIndex: 2
    },
    loaderContainer: {
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '64px',
        width: '64px'
    }
})

export type PlayControlsProps = {
    /**
     * a type of the status.
     */
    status: 'playing' | 'stopped' | 'loading'
    /**
     * function callback.
     */
    onClick: () => void
    /**
     * when to show component (e.g on hover).
     */
    visible: boolean
}

export function PlayControls({ status, onClick, visible }: PlayControlsProps) {
    const classes = useStyles()

    if (status === 'loading') {
        return (
            <Box className={classes.loaderContainer}>
                <CircularProgress className={classes.loader} />
            </Box>
        )
    }

    return (
        <Box className={clsx(classes.playControls, visible && classes.active)}>
            <Button
                disableFocusRipple
                disableRipple
                className={classes.playButton}
                size="small"
                onClick={onClick}
            >
                {status === 'playing' && (
                    <PauseIcon fontSize="large" style={{ color: '#fff' }} />
                )}
                {status === 'stopped' && (
                    <PlayIcon fontSize="large" style={{ color: '#fff' }} />
                )}
            </Button>
        </Box>
    )
}
